export const ServicesItems = [
  {
    title: 'service_details.details.items.header_1',
    description: 'service_details.details.items.description_1',
  },
  {
    title: 'service_details.details.items.header_2',
    description: 'service_details.details.items.description_2',
  },
  {
    title: 'service_details.details.items.header_3',
    description: 'service_details.details.items.description_3',
  },
  {
    title: 'service_details.details.items.header_4',
    description: 'service_details.details.items.description_4',
  },
  {
    title: 'service_details.details.items.header_5',
    description: 'service_details.details.items.description_5',
  },
  {
    title: 'service_details.details.items.header_6',
    description: 'service_details.details.items.description_6',
  },
  {
    title: 'service_details.details.items.header_7',
    description: 'service_details.details.items.description_7',
  },
]
